import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { v4 as uuidV4 } from 'uuid';

import FetchItem from 'my-components/FetchItem';

import ImageControls from './ImageControls';

import * as attachmentActions from 'my-actions/AttachmentActions';
import { fetchAttachment } from 'my-actions/AttachmentActions';

class ImageControlsCtnr extends Component {
  state = {
    saving: false,
    uploadCid: null,
    imageId: null,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.saving && nextProps.attachmentsStatus.create) {
      const { cId, success } = nextProps.attachmentsStatus.create;
      if (cId === prevState.uploadCid && success) {
        return {
          saving: false,
          uploadCid: null,
        };
      }
    }
    return null;
  }

  componentDidUpdate(_, prevState) {
    const { attachments, onEditComplete } = this.props;
    if (prevState.saving && !this.state.saving) {
      const attachment = Object.values(attachments).find(image => image.cId === prevState.uploadCid);
      onEditComplete({ id: attachment.id, url: attachment.urls.original });
    }
  }

  saveCroppedImage = (newCanvas, fileName, original_id) => {
    const { attachmentActions } = this.props;
    const uploadCid = uuidV4();
    newCanvas.toBlob(blob => {
      attachmentActions.startAttachmentUpload(new File([blob], `${fileName}.png`, { type: 'image/png' }), uploadCid, {
        original_id,
      });
    }, 'image/png');
    this.setState({ saving: true, uploadCid });
  };

  // for renaming image or updating editor if user has reverted to original image
  updateImage = (attachment, params) => {
    const { attachmentActions, onEditComplete } = this.props;
    if (params) attachmentActions.updateAttachment(attachment.id, params);
    onEditComplete({ id: attachment.id, url: attachment.urls.original });
  };

  overrideAttachmentId = id => {
    this.setState({ imageId: id });
  };

  render() {
    const { imgId, onClose, showDialog } = this.props;
    const attachmentId = this.state.imageId || imgId;
    return (
      <FetchItem entity="attachments" entityId={attachmentId} fetchAction={fetchAttachment} fetchOnMount>
        {({ fetchError, fetching, item }) => {
          return (
            <ImageControls
              key={attachmentId}
              attachment={item}
              fetchError={fetchError}
              fetching={fetching}
              onClose={onClose}
              onCrop={this.saveCroppedImage}
              onRevert={this.overrideAttachmentId}
              onUpdate={this.updateImage}
              showDialog={showDialog}
            />
          );
        }}
      </FetchItem>
    );
  }
}

export default connect(
  state => ({
    attachments: state.attachments.items,
    attachmentsStatus: state.attachments.status,
  }),
  dispatch => ({
    attachmentActions: bindActionCreators(attachmentActions, dispatch),
  }),
)(ImageControlsCtnr);
